module.exports = __webpack_public_path__ + "static/img/7.39ab0b9c.jpg";